import { useSession } from '@/context/SessionProvider'
import { MsgExecuteContractCompat, TokenMoney } from '@ninjablaze/sdk-ts'
import { useBalanceStore } from '@/context/UserBalance'
import { AppModals, useAppModal } from '@/context/ModalProvider'
import { BONUS_ACCOUNT_CONTRACT, SHU_DENOM } from '@/constants/constants'
import { BigNumber } from 'bignumber.js'

export const placeBetTransaction = async ({
  contract_addr,
  funds,
  msg,
  lockBalance = false,
}: {
  contract_addr: string
  funds: TokenMoney | { denom: string; amount: string }
  msg: any
  lockBalance?: boolean
}) => {
  const { account, signIn, sendTransaction } = useSession.getState()

  if (!account) {
    signIn()
    return
  }

  const { balance } = useBalanceStore.getState()

  const bet = funds instanceof TokenMoney ? funds : TokenMoney.fromHuman(funds.amount, funds.denom)
  if (!balance[funds.denom] || balance[funds.denom].amount.chainValue.lt(bet.chainValue)) {
    // Open SHU faucet modal if insufficient SHU balance, otherwise open deposit modal
    if (funds.denom === SHU_DENOM) {
      useAppModal.getState().openModalNew(AppModals.ShuFaucet)
    } else {
      if (balance[funds.denom].full_balance.chainValue.gte(bet.chainValue)) {
        const walletBalance = balance[funds.denom].amount.humanNumber
        const gameBalance = balance[funds.denom].game_balance.humanNumber

        useAppModal.getState().openModalNew(AppModals.InsufficientNeedCoverFromGameAccount, {
          currency: funds.denom,
          betAmount: bet.humanNumber,
          walletBalance,
          gameBalance,
          afterReturnBalance: Number(walletBalance) + Number(gameBalance),
        })
      } else {
        useAppModal.getState().openModalNew(AppModals.DepositModal2)
      }
    }
    return
  }

  let msgExecute = undefined as MsgExecuteContractCompat | undefined

  if (balance[funds.denom].bonus.chainValue.lte(0)) {
    msgExecute = MsgExecuteContractCompat.fromJSON({
      sender: account?.injectiveAddress!,
      funds: [bet.toCoin()],
      contractAddress: contract_addr,
      msg: {
        join: {
          player: account?.injectiveAddress!,
          ...msg,
        },
      },
    })
  } else {
    const bonusAmount = balance[funds.denom].bonus.chainValue.minus(bet.chainValue)
    let walletPay = undefined
    if (bonusAmount.isNegative()) {
      walletPay = BigNumber.min(bonusAmount.abs(), bet.chainValue)
    }
    msgExecute = MsgExecuteContractCompat.fromJSON({
      sender: account?.injectiveAddress!,
      funds: walletPay?.gt(0)
        ? [
          {
            denom: funds.denom,
            amount: walletPay.toString(),
          },
        ]
        : undefined,
      contractAddress: BONUS_ACCOUNT_CONTRACT,
      msg: {
        execute: {
          contract_addr: contract_addr,
          funds: bet.toCoin(),
          msg: Buffer.from(
            JSON.stringify({
              join: {
                ...msg,
              },
            })
          ).toString('base64'),
        },
      },
    })
  }

  const tx = await sendTransaction(msgExecute, { showSuccess: false, showError: false })

  if (lockBalance) {
    useBalanceStore.getState().lockBalance(tx!.height)
  }

  return tx
}
